import React from 'react';
import { Box, Breadcrumbs, Typography, Link as MUILink, Button } from '@mui/material';
import { Link as RouterLink, useLocation, useParams, useNavigate } from 'react-router-dom';
import ExplorePreview from './ExplorePreview';

const DEFAULT_RETURN = '/hotelInfo?tab=6';

export default function ExplorePreviewPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const returnTo = location.state?.returnTo || DEFAULT_RETURN;

  return (
    <Box sx={{ px: 4, pt: 3, pb: 6 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <MUILink component={RouterLink} underline="hover" color="inherit" to={returnTo}>
          Explore Posts
        </MUILink>
        <Typography color="text.primary">Preview</Typography>
      </Breadcrumbs>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="outlined" size="small" onClick={() => navigate(returnTo)}>
          Back to Explore
        </Button>
      </Box>

      <ExplorePreview hideBack postId={id} />
    </Box>
  );
}
